import { HttpClient } from '@angular/common/http';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { IID } from 'app/model/id';
import { RESTObject } from '../angular-rest';

export interface IIntervallo {
	id?: number;
	inizio: NgbTimeStruct;
	fine: NgbTimeStruct;
	ambulatorio?: string;
	isagendamedico?: number;
}

export class Intervallo extends RESTObject<IIntervallo> implements IID<number> {

	id: number;
	giorno?: number

	constructor($http: HttpClient, uri: string, defaultValue: IIntervallo, giorno?: number) {
		super($http, uri, defaultValue);
		this.id = defaultValue.id;
		this.giorno = giorno
	}
}



// WEBPACK FOOTER //
// ./src/app/model/ambulatorio.ts